/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.75 5.25C6.75 2.3505 9.1005 0 12 0s5.25 2.3505 5.25 5.25V6h2.4407c1.1251 0 2.0773.8312 2.2293 1.946l.3856 2.8277a.75.75 0 1 1-1.4862.2026l-.3856-2.8276a.75.75 0 0 0-.7431-.6487H17.25v.75a.75.75 0 0 1-1.5 0V7.5h-7.5v.75a.75.75 0 1 1-1.5 0V7.5H4.3094a.75.75 0 0 0-.7432.6487L1.9575 19.946c-.1842 1.351.8659 2.554 2.2294 2.554H12a.75.75 0 0 1 0 1.5H4.1869C1.9144 24 .1642 21.9949.4713 19.7433L2.08 7.946C2.232 6.8312 3.1842 6 4.3094 6H6.75v-.75Zm9 0V6h-7.5v-.75C8.25 3.179 9.929 1.5 12 1.5c2.0711 0 3.75 1.679 3.75 3.75Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M23.2426 15.6034a.75.75 0 0 0-1.0606-1.0607L19 17.7247l-3.182-3.182a.75.75 0 0 0-1.0606 0 .75.75 0 0 0 0 1.0606l3.1819 3.182-3.1819 3.182a.75.75 0 0 0 1.0606 1.0607L19 19.846l3.182 3.182a.75.75 0 0 0 1.0606-1.0607l-3.1819-3.182 3.1819-3.1819Z"
    />
  </React.Fragment>,
  'RemoveMarketPlace'
);
